import { IComponentOptions, IOnInit } from "angular";
import { ProcessTimelineComponentController } from "./controller";

import "./styles.css";

export const vsComponentName = "processTimeline";

export const ProcessTimelineComponentOptions: IComponentOptions = {
  controllerAs: "processTimelineController",
  controller: ProcessTimelineComponentController,
  template: require("!html-loader!./index.html").default,
  bindings: {
    process: "<",
    processInformation: "<",
  },
};
